import { Icon } from "@focus/focusUI";
import type { ReleaseNote } from "../../types/releaseNotes";

type ReleaseNoteCardProps = {
  releaseNote: ReleaseNote;
  expanded?: boolean;
  onToggleExpanded?: (id: string) => void;
};

export const ReleaseNoteCard = ({
  releaseNote,
  expanded,
  onToggleExpanded,
}: ReleaseNoteCardProps) => {
  return (
    <article className="rounded-xl border bg-white p-4 shadow-sm">
      <header className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          <h3 className="truncate text-base font-bold text-slate-900">
            {releaseNote.title}
          </h3>

          <div className="mt-1 flex items-center gap-2 text-sm text-slate-500">
            <span>v{releaseNote.version}</span>
            <span>•</span>
            <span>{releaseNote.releaseDate}</span>
          </div>
        </div>

        <button
          onClick={() => onToggleExpanded(releaseNote.documentId)}
          type="button"
        >
          <Icon icon={expanded ? "chevron-up" : "chevron-down"} />
        </button>
      </header>

      {expanded && (
        <div className="mt-4 border-t pt-4">
          <p className="whitespace-pre-wrap text-sm text-slate-700">
            {releaseNote.description}
          </p>
        </div>
      )}
    </article>
  );
};
